"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _EpicSubscriptionLogin = require("./EpicSubscriptionLogin");

var _EpicSubscriptionLogin2 = _interopRequireDefault(_EpicSubscriptionLogin);

var _EpicSubscriptionSubscribe = require("./EpicSubscriptionSubscribe");

var _EpicSubscriptionSubscribe2 = _interopRequireDefault(_EpicSubscriptionSubscribe);

var _MigrationBoxFooter = require("./MigrationBoxFooter");

var _MigrationBoxFooter2 = _interopRequireDefault(_MigrationBoxFooter);

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicSubscription = function (_React$Component) {
  (0, _inherits3.default)(EpicSubscription, _React$Component);

  function EpicSubscription() {
    (0, _classCallCheck3.default)(this, EpicSubscription);
    return (0, _possibleConstructorReturn3.default)(this, (EpicSubscription.__proto__ || (0, _getPrototypeOf2.default)(EpicSubscription)).apply(this, arguments));
  }

  (0, _createClass3.default)(EpicSubscription, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          subscriptionError = _props.subscriptionError,
          isEpicLogin = _props.isEpicLogin,
          subscribeToUnrealUnlimited = _props.subscribeToUnrealUnlimited,
          subscribing = _props.subscribing,
          shouldUpdateEula = _props.shouldUpdateEula,
          welcome = _props.welcome;


      return _react2.default.createElement(
        "section",
        null,
        !isEpicLogin ? _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            _components.Popup.Content,
            null,
            _react2.default.createElement(_EpicSubscriptionLogin2.default, null)
          ),
          _react2.default.createElement(_MigrationBoxFooter2.default, null)
        ) : _react2.default.createElement(_EpicSubscriptionSubscribe2.default, {
          subscriptionError: subscriptionError,
          subscribing: subscribing,
          subscribeToUnrealUnlimited: subscribeToUnrealUnlimited,
          shouldUpdateEula: shouldUpdateEula,
          welcome: welcome
        })
      );
    }
  }]);
  return EpicSubscription;
}(_react2.default.Component);

exports.default = EpicSubscription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscription.jsx
// module id = 2910
// module chunks = 0